import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem("revops_token"));
  const [user, setUser]   = useState(() => {
    try { return JSON.parse(localStorage.getItem("revops_user")); } catch { return null; }
  });

  const login = (tok, usr) => {
    setToken(tok); setUser(usr);
    localStorage.setItem("revops_token", tok);
    localStorage.setItem("revops_user", JSON.stringify(usr));
  };

  const logout = () => {
    setToken(null); setUser(null);
    localStorage.removeItem("revops_token");
    localStorage.removeItem("revops_user");
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
